import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { fetchAvailableComponents } from '@/lib/edge-api'
import type { CatalogComponent } from '@/types/components'

/**
 * Fetches available components for the current tenant user from the Edge API.
 * Components outside the tenant's plan are returned with locked: true.
 */
export function useCatalogComponents() {
  return useQuery<CatalogComponent[]>({
    queryKey: ['catalog-components'],
    queryFn: async () => {
      const { data: sessionData } = await supabase.auth.getSession()
      const token = sessionData.session?.access_token
      if (!token) throw new Error('Not authenticated')
      return fetchAvailableComponents(token)
    },
    staleTime: 60_000,  // components change rarely; reuse for 1 minute
    gcTime: 5 * 60_000,
  })
}
